export const LABEL_MESSAGES = {
  CargoId: 'Cargo',
  CodigoInterno: 'Código Interno',
  NomeInterno: 'Nome Interno',
  AncoraId: 'Rede',
  BancoId: 'Banco',
  OrigemContato: 'Origem Contato',
  ClassificacaoFornecedorId: 'Classificação Fornecedor',
  CnpjCpf: 'CPF/CNPJ',
  RaizCnpjCpf: 'Raiz CPF/CNPJ',
  TipoPessoa: 'Tipo Pessoa',
  MunicipioId: 'Município',
  EstadoId: 'Estado',
  RamoAtividadeId: 'Ramo Atividade',
  GrupoFornecedorId: 'Grupo Fornecedor',
  NomeFantasia: 'Nome Fantasia',
  RazaoSocial: 'Razão Social',
  Ocorrencia: 'Ocorrência',
  DataAgendamento: 'Data agendamento',
  SenhaAtual: 'Senha Atual',
  SenhaNova: 'Nova Senha',
  SenhaNovaConfirmacao: 'Confirmação Senha Nova',
};
